module.exports = "../dist/img/white-28.bf61.jpg";